// extracted by mini-css-extract-plugin
export default {"leng_list_title":"languagesDraver_leng_list_title__tCaYY","save_button_div":"languagesDraver_save_button_div__uWbKL","save_button":"languagesDraver_save_button__R7D0h"};